// extracted by mini-css-extract-plugin
export var grid = "_1p-0";
export var span1 = "_1p-2";
export var span10 = "_1p-b";
export var span10L = "_1p-z";
export var span10M = "_1p-n";
export var span10Xl = "_1p-1b";
export var span11 = "_1p-c";
export var span11L = "_1p-10";
export var span11M = "_1p-o";
export var span11Xl = "_1p-1c";
export var span12 = "_1p-d";
export var span12L = "_1p-11";
export var span12M = "_1p-p";
export var span12Xl = "_1p-1d";
export var span1L = "_1p-q";
export var span1M = "_1p-e";
export var span1Xl = "_1p-12";
export var span2 = "_1p-3";
export var span2L = "_1p-r";
export var span2M = "_1p-f";
export var span2Xl = "_1p-13";
export var span3 = "_1p-4";
export var span3L = "_1p-s";
export var span3M = "_1p-g";
export var span3Xl = "_1p-14";
export var span4 = "_1p-5";
export var span4L = "_1p-t";
export var span4M = "_1p-h";
export var span4Xl = "_1p-15";
export var span5 = "_1p-6";
export var span5L = "_1p-u";
export var span5M = "_1p-i";
export var span5Xl = "_1p-16";
export var span6 = "_1p-7";
export var span6L = "_1p-v";
export var span6M = "_1p-j";
export var span6Xl = "_1p-17";
export var span7 = "_1p-8";
export var span7L = "_1p-w";
export var span7M = "_1p-k";
export var span7Xl = "_1p-18";
export var span8 = "_1p-9";
export var span8L = "_1p-x";
export var span8M = "_1p-l";
export var span8Xl = "_1p-19";
export var span9 = "_1p-a";
export var span9L = "_1p-y";
export var span9M = "_1p-m";
export var span9Xl = "_1p-1a";
export var stretch = "_1p-1";